import { render, staticRenderFns } from "./InternalShareIcon.vue?vue&type=template&id=cdcea0b4"
import script from "./InternalShareIcon.vue?vue&type=script&lang=js"
export * from "./InternalShareIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports